<div class="popup-bg">
<div class="view-img-dialog">
  <button type="button" class="close-btn" (click)="onCancel()" aria-label="Close">
    <i class="fa fa-times"></i>
  </button>
  <div class="main-img-wrapper position-relative d-flex align-items-center justify-content-center">
    <button
      type="button"
      class="arrow-btn left-arrow"
      (click)="selectImage((selectedIndex - 1 + imageUrls.length) % imageUrls.length)"
      [disabled]="imageUrls.length <= 1"
      aria-label="Previous"
    >
      <i class="fa fa-chevron-left"></i>
    </button>
    <ng-magnizoom
      zoomMode="LENS"
      [imageStyle]="{ 'max-width': '100%', 'max-height': '60vh', 'border-radius': '50%', 'background': '#f6f6f6' }"
      [imageClass]="{ 'img-fluid': true, 'main-img': true, 'animate-img-in': true }"
      [imageSrc]="imageUrls[selectedIndex]">
    </ng-magnizoom>
    <button
      type="button"
      class="arrow-btn right-arrow"
      (click)="selectImage((selectedIndex + 1) % imageUrls.length)"
      [disabled]="imageUrls.length <= 1"
      aria-label="Next"
    >
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>
  <div class="thumbnails mt-3 d-flex justify-content-center">
    <img *ngFor="let url of imageUrls; let idx = index"
         [src]="url"
         class="img-thumbnail mx-1 animate-thumb-in"
         [class.selected]="idx === selectedIndex"
         (click)="selectImage(idx)">
  </div>
</div>
</div>